$(document).ready(function(){
   setTimeout(function(){

  const config = {
  productId: 5783955079331, // Required
  injectionParent: '.product-form-template--16542947344547__product-grid1', // The node that will have the widget injected in
  injectionMethod: 'prepend', // How will the widget be injected 
  injectFn: (node, target) => {}, // Runs a custom injection function 
  selectors: {
  price: ['.my-price-selector'], // the selectors that will be updated based on subscription
    variant: ['.product-form-template--16542947344547__product-grid1-input'] // The variants to watch for to update the subscription prices
  }
};
//window.ReChargeWidget.createWidget(config);


const config2 = {
  productId: 5742267531427, // Required
  injectionParent: '.product-form-template--16542947344547__product-grid2', // The node that will have the widget injected in
  injectionMethod: 'prepend', // How will the widget be injected 
  injectFn: (node, target) => {}, // Runs a custom injection function 
  selectors: {
    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
    variant: ['.product-form-template--16542947344547__product-grid2-input'] // The variants to watch for to update the subscription prices
  }
};

//window.ReChargeWidget.createWidget(config2);  

const config3 = {
  productId: 6089948332195,// Required
  injectionParent: '.product-form-template--16542947344547__product-grid3', // The node that will have the widget injected in
  injectionMethod: 'prepend', // How will the widget be injected 
  injectFn: (node, target) => {}, // Runs a custom injection function 
  selectors: {
  price: ['.my-price-selector'], // the selectors that will be updated based on subscription
    variant: ['.product-form-template--16542947344547__product-grid3-input'] // The variants to watch for to update the subscription prices
  }
};
// window.ReChargeWidget.createWidget(config3);


const config4 = {
  productId: 6100372455587,// Required
  injectionParent: '.product-form-template--16542947344547__product-grid4', // The node that will have the widget injected in
  injectionMethod: 'prepend', // How will the widget be injected 
  injectFn: (node, target) => {}, // Runs a custom injection function 
  selectors: {
    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
    variant: ['.product-form-template--16542947344547__product-grid4-input'] // The variants to watch for to update the subscription prices
  }
};

window.ReChargeWidget.createWidgets([config, config2, config3, config4]);
  

     
     
   },2300)
      
});







